import React from 'react'

import { CUSTOM_TEMPLATE, NO_TEMPLATE } from '../../_templates/Constants'
import { Title } from '../../../../../packages/kiti/components/presentation/Text'
import { usePdfOptionsForm } from '../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import { FlexCol } from '../../../../../components/structure/FlexGrid'
import Accordion from '../../../../../components/structure/accordion/Accordion'
import AccordionHeader from '../../../../../components/structure/accordion/AccordionHeader'
import { Grid } from '../../../../../packages/kiti/components/structure/Grid'
import AccordionContent from '../../../../../components/structure/accordion/AccordionContent'
import QrCodePosition from './QrCode/QrCodePosition'
import QrCodeSize from './QrCode/QrCodeSize'

export const QrCodeSection = () => {
  const form = usePdfOptionsForm()

  if (![CUSTOM_TEMPLATE, NO_TEMPLATE].includes(form.template)) return false

  const isNoTemplate = [NO_TEMPLATE].includes(form.template)

  return (
    <FlexCol>
      <Accordion startsOpen={isNoTemplate} lineBorder mediumPadding={true} noRadius>
        <AccordionHeader>
          <Grid justify="space-between">
            <Title size="h6" noMargin>
              QR Code
            </Title>
          </Grid>
        </AccordionHeader>
        <AccordionContent>
          <QrCodePosition />
          <QrCodeSize />
        </AccordionContent>
      </Accordion>
    </FlexCol>
  )
}

export default QrCodeSection
